var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      directives: [
        {
          name: "analytics",
          rawName: "v-analytics",
          value: _vm.analytics,
          expression: "analytics",
        },
      ],
      class: _vm.$data.class,
      attrs: { href: _vm.link, target: _vm.external ? "_blank" : null },
    },
    [_vm._v(_vm._s(_vm.label))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }